<template>
  <div>
    <div
      class="d-md-flex justify-content-between flex-column mt-3 mb-3"
      :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'flex-lg-row' : ''"
    >
      <div
        class="col-12"
        :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-lg-7' : ''"
      >
        <div class="mt-3">
          <div class="container-fluid w-100 text-center">
            <div
              v-if="getDescription && getDescription.length"
            >
              <p
                v-for="(paragraph, paragraphIndex) in getDescription"
                :key="`description-paragraph-${paragraphIndex}`"
                class="my-3 mx-0 p-0"
              >
                {{ paragraph }}
              </p>
            </div>
          </div>
          <div
            v-if="experienceItem.experience && experienceItem.experience.meals && experienceItem.experience.meals.length"
            class="d-flex flex-column flex-lg-row th-info"
          >
            <div
              class="col-12"
              :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-md-5' : 'col-md-3'"
            >
              <h4>Meal Inclusions</h4>
            </div>
            <div
              class="col-12"
              :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-md-7' : 'col-md-3'"
            >
              <p 
                v-for="(meal, mealIndex) in experienceItem.experience.meals" 
                :key="`meal-${mealIndex}`"
              >
                Includes {{ meal }}
              </p>    
            </div>
          </div>
          <div
            v-if="experienceItem.experience && experienceItem.experience.meals && experienceItem.experience.meals.length && serviceTravellers"
            class="col-12 col-md-7"
          >
            <hr class="m-0">
          </div>
          <div 
            v-if="serviceTravellers" 
            class="d-flex flex-column flex-lg-row th-info"
          >
            <div
              class="col-12"
              :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-md-5' : 'col-md-3'"
            >
              <h4>Reservation For</h4>
            </div>
            <div
              class="col-12"
              :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-md-6' : 'col-md-3'"
            >
              <p>{{ serviceTravellers }}</p>   
            </div> 
          </div>
        </div>
      </div>
      <div
        class="col-12"
        :class="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length) || (experienceItem.media && experienceItem.media.images && experienceItem.media.images.length) || displayDefinedElementButton ? 'col-lg-5' : ''"
      >
        <div
          v-if="experienceItem.media && experienceItem.media.images && experienceItem.media.images.length"
          class="d-flex flex-column"
        >
          <div
            class="w-100 gallery-button mb-3 mt-2"
            @click="handleOpenExperienceImageModal"
          >
            <img
              v-if="experienceItem && 
                experienceItem.media && 
                experienceItem.media.images &&
                experienceItem.media.images.length" 
              :src="experienceItem.media.images.length ? addCdnImageWidth(experienceItem.media.images[0], 600) : 'https://images.unsplash.com/photo-1535262412227-85541e910204?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTV8fGJlYWNofGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60'"
              alt="experience image"
              class="th-service-image"
            >
            <button 
            class="w-100 m-0 th-button text-center justify-content-center rounded th-acc-btn" 
            >
            <div class="flex justify-content-center p-0 m-0">
              <b-icon
                class="th-button-icon-gallery"
                icon="camera"
              />
              <span class="pl-1">Gallery</span>
              <div class="th-button-placeholder" />
            </div>
            </button>
          </div>
        </div>
        <button
          v-if="experienceItem.additionalInfoExt || experienceItem.customDescription || (experienceItem.dateRangeMessages && experienceItem.dateRangeMessages.length)"
          class="w-100 th-button text-center rounded th-ess-info-btn mb-3 mt-3 mx-auto" 
          @click="handleOpenEssInfoAccModal"
        >
          Essential Experience Information
        </button>
        <button
          v-if="displayDefinedElementButton"
          class="w-100 th-button text-center rounded th-acc-btn mb-3 mt-3 mx-auto" 
          @click="handleOpenDefinedInfoModal(experienceItem.definedElementTypes)"
        >
          Detailed Experience Information
        </button>
      </div>
    </div><!-- Transport items and experience items currently use the same image modal -->
    <ExperienceImageModal
      ref="experienceImageModal"
      :experience-item="experienceItem"
    />
    <EssentialInfoAccModal
      ref="essInfoAccModal"
      :additional-information="experienceItem.additionalInfoExt"
      :custom-description="experienceItem.customDescription"
      :date-range-messages="experienceItem.dateRangeMessages"
      title="Essential Information"
      :date="experienceItem.groupdate"
    />
    <DefinedInfoModal
      ref="defined-info-modal"
    />
  </div>
</template>

<script>
import { outputTravellers, definedElementTypeCheck } from '../utils'
import ExperienceImageModal from '../modals/experience-image-modal.vue'
import EssentialInfoAccModal from '../modals/essential-info-acc-modal.vue'
import DefinedInfoModal from '../modals/defined-info-modal.vue'
import imagePlaceholder from '../images/image-placeholder.png'
import { addCdnImageWidth } from '@/lib/utilities'
export default {
  components: {
    // Slider,
    ExperienceImageModal,
    EssentialInfoAccModal,
    DefinedInfoModal
  },
  props: {
    experienceItem: {
      type: Object
    },
    tourTravellers: {
      type: Array
    }
  },
  data () {
    return {
      serviceTravellers: false,
      imagePlaceholder,
      descriptionArray: [],
      displayDefinedElementButton: false
    }
  },
  computed: {
    getDescription () {
    return this.descriptionArray
  }
  },
  mounted () {
    this.setReservationFor()
    this.buildDescriptionParagraphs(this.experienceItem.description)
    this.displayDefinedElementButton = definedElementTypeCheck(this.experienceItem)
  },
  methods: {
    addCdnImageWidth,
    setReservationFor () {
      if (this.tourTravellers.length === this.experienceItem.travellers.length) {
        this.serviceTravellers = false
      } else {
        const travellers = this.experienceItem.travellers
        this.serviceTravellers = outputTravellers(travellers)
      }
    },
    handleOpenExperienceImageModal () {
      this.$refs.experienceImageModal.showModal()
    },
    handleOpenEssInfoAccModal () {
      this.$refs.essInfoAccModal.showModal()
    },
    handleOpenDefinedInfoModal (definedInfoData) {
      this.$refs['defined-info-modal'].openModal(definedInfoData)
    },
    buildDescriptionParagraphs (description) {
      const paragraphArray = description.split('\n')
      this.descriptionArray = paragraphArray
    }
  }
  };
  </script>
  
  <style lang="scss">
  @import "../../styles.scss";
  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-end {
    width: 300px;
  }
  .toggle {
    display: flex;
    justify-content: flex-end;
  }
  .th-button-icon-gallery {
    font-size: 16px;
    margin-top: 5px;
  }
  @media (max-width: 800px) {
    .th-toggle-button {
      margin-top: 0.5rem !important;
    }
  }
  </style>